import './Footer.css';
import { useAppContext } from '../services/AppService';
import React from "react";

export const Footer: React.FC = () => {
	const { setState } = useAppContext();

	return (
		<div onClick={() => setState('hamburgerMenuIsOpen', false)} className='footer'>
			<span className='copyright'>Copyright &copy; {new Date().getFullYear()} Ergotron</span>
			<span className='street'>1181 Trapp Road</span>
			<span className='city-state'>Eagan, MN 55121</span>
			<span className='website'>
				<a 
				className='website-link'
					href='https://www.ergotron.com'
					target='_blank'
					rel='noopener noreferrer'
				>
					www.ergotron.com{' '}
				</a>
			</span>
		</div>
	)
}